import React, { useEffect, useState } from "react";
import ElementRow from "./ElementRow";
import { getElementsOverview } from "../../Services/elementsOverview";

const getProfileAvatar = () => {
  try {
    const raw = localStorage.getItem("profile");
    if (!raw) return null;
    const profile = JSON.parse(raw);
    return profile?.profile_pic_url || null;
  } catch (_) {
    return null;
  }
};

const getProfileInitial = () => {
  try {
    const raw = localStorage.getItem("profile");
    if (!raw) return "?";
    const profile = JSON.parse(raw);
    const name = profile?.first_name || profile?.name || profile?.email || "";
    return (name.trim()[0] || "?").toUpperCase();
  } catch (_) {
    return "?";
  }
};

const YourElementsList = ({ onSelectItem }) => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOverview = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getElementsOverview();
      setOverview(data);
    } catch (err) {
      setError("We couldn't load your elements. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getElementsOverview();
        if (!cancelled) setOverview(data);
      } catch (err) {
        if (!cancelled) setError("We couldn't load your elements. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const avatar = getProfileAvatar();

  if (loading) {
    return (
      <div className="ye-state">
        <div className="ye-spinner" />
        <p>Loading your elements…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ye-state">
        <p>{error}</p>
        <button className="ye-retry" onClick={fetchOverview}>Try again</button>
      </div>
    );
  }

  const header = overview?.header || {};
  const items = (overview?.items || []).slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <>
      <div className="ye-list-header">
        {avatar
          ? <img className="ye-avatar" src={avatar} alt="" />
          : <div className="ye-avatar-fallback">{getProfileInitial()}</div>}
        {header.title && <h2 className="ye-list-title">{header.title}</h2>}
        {header.description && <p className="ye-list-description">{header.description}</p>}
      </div>
      <div className="ye-rows">
        {items.map((item) => (
          <ElementRow
            key={item.item_id || item.domain_key}
            item={item}
            onClick={onSelectItem}
          />
        ))}
      </div>
    </>
  );
};

export default YourElementsList;
